import { render } from "./ReportsHeader.vue?vue&type=template&id=f2e3bf26&scoped=true"
import script from "./ReportsHeader.vue?vue&type=script&lang=js"
export * from "./ReportsHeader.vue?vue&type=script&lang=js"

import "./ReportsHeader.vue?vue&type=style&index=0&id=f2e3bf26&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e3bf26"]])

export default __exports__